import {
  ChallengeEntryField,
  ChallengeFieldColumn,
  ChallengeFieldError,
  ChallengeRow,
  ChallengeRowLabel,
  ChallengeRowNumber,
} from '@/components/challenge/components';
import { getStatusAdornment } from '@/components/challenge/UserChallenge/getStatusAdornment';
import { TSaveStatus } from '@/hooks/useFieldSaveStatus';
import { NumberFormatCustom } from '@/components/form-elements/NumberInput';
import { IChallengeLabel } from '@/types/challenges';
import { FC } from 'react';

const MAX_ENTRY_VALUE = 9999999;

interface ChallengeEntryRowProps {
  entry: IChallengeLabel;
  displayIndex: number;
  value: number | '';
  status: TSaveStatus | undefined;
  errorMessage: string | undefined;
  onChange: (value: string) => void;
  onFocus: () => void;
  onBlur: () => void;
}

export const ChallengeEntryRow: FC<ChallengeEntryRowProps> = ({
  entry,
  displayIndex,
  value,
  status,
  errorMessage,
  onChange,
  onFocus,
  onBlur,
}) => (
  <ChallengeRow>
    <ChallengeRowNumber>{displayIndex + 1}.</ChallengeRowNumber>
    <ChallengeRowLabel>{entry.label}</ChallengeRowLabel>
    <ChallengeFieldColumn>
      <ChallengeEntryField
        name={`entry-${entry.index}`}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        inputComponent={NumberFormatCustom as any}
        inputProps={{
          allowNegative: false,
          decimalScale: 0,
          max: MAX_ENTRY_VALUE,
        }}
        error={status === 'error'}
        endAdornment={getStatusAdornment(status)}
      />
      {errorMessage && (
        <ChallengeFieldError>{errorMessage}</ChallengeFieldError>
      )}
    </ChallengeFieldColumn>
  </ChallengeRow>
);
